<template>
  <div :class="ns.b()">
    <div :class="ns.e('image')" :style="imageStyle">
      <img v-if="image" :src="image" ondragstart="return false" />
      <slot v-else name="image">
        <img :src="imgSrc" ondragstart="return false"/>
      </slot>
    </div>
    <div :class="ns.e('description')">
      <slot v-if="$slots.description" name="description"></slot>
      <p v-else>{{ emptyDescription }}</p>
    </div>
    <div v-if="$slots.default" :class="ns.e('bottom')">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, unref } from 'vue'
import get from 'lodash/get'
import { useLocale, useNamespace } from '@sgui-plus/hooks'
import pageStatusImg from './pageStatusImg'
import { pageStatusProps } from './page-status'

export default defineComponent({
  name: 'SgPageStatus',

  props: pageStatusProps,

  setup(props) {
    const { locale, t } = useLocale()
    const ns = useNamespace('page-status')
    const emptyDescription = computed(
      () => props.description || (get(unref(locale), `sg.pageStatus.${props.type}`) ? t(`sg.pageStatus.${props.type}`) : '')
    )
    const imgSrc = computed<string>(() => pageStatusImg[`${props.theme}-${props.type}`])

    return {
      ns,
      emptyDescription,
      imgSrc
    }
  },
})
</script>
